export default __webpack_public_path__ + "static/media/tvl-icon.903db7bd.svg";